<div class="item_card_wrap">
    <div class="card_con">
        <img src="assets/imgs/bag_icon.png" alt="가방 아이콘">
        <div class="text_box">
            <span>스마트 가방</span>
        </div>
    </div>
    <div class="dis_drop"></div>
</div>